import { MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import connectSearchBox from 'instantsearch.js/es/connectors/search-box/connectSearchBox';
import connectHits from 'instantsearch.js/es/connectors/hits/connectHits';
import { FirebaseService } from 'src/app/services/firebase.service';
import { StateService } from 'src/app/services/state.service';
import InstantSearch from 'instantsearch.js/es/lib/InstantSearch';
import algoliasearch from 'algoliasearch/lite';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-choose-client',
    templateUrl: './choose-client.component.html',
    styleUrls: ['./choose-client.component.scss'],
    standalone: false,
})
export class ChooseClientComponent implements OnInit {
    public hits: any[] = [];
    public refine: (query: string) => void = () => {};
    public query = '';
    public instantSearchInstance!: InstantSearch;

    constructor(
        private stateService: StateService,
        public firebaseService: FirebaseService,
        public dialogRef: MatDialogRef<ChooseClientComponent>,
    ) {
        const searchClient = algoliasearch(environment.algoliaAppId, this.stateService.searchKey.getValue().searchkey);

        this.instantSearchInstance = new InstantSearch({
            searchClient,
            indexName: 'clients',
        });
        this.instantSearchInstance.addWidgets([
            connectSearchBox(({ refine, query }) => {
                this.refine = refine;
                this.query = query;
            })({}),
            connectHits(({ hits }) => {
                this.hits = hits;
            })({}),
        ]);
    }

    ngAfterContentInit() {
        this.start();
    }

    public search(event: Event) {
        this.refine!((event.target as HTMLInputElement).value);
    }

    ngOnInit() {}

    start() {
        if (this.instantSearchInstance.started) {
            return;
        }
        this.instantSearchInstance.start();
    }
    async chooseClient(searchClient: any) {
        const client = await this.firebaseService.getClientPromise(searchClient.clientId);
        this.dialogRef.close({ client: client });
    }

    trackByObjectID(index: number, item: any): any {
        return item.objectID || item.id || index;
    }
}
